// modules
import { addModal } from 'weblite-web-modal-viewer'
// component
import { HonarioonPhoneMenu } from './honarioon-phone-menu'

const COMPONENT_ID = 'honarioonPhoneMenu'

export const showHonarioonPhoneMenu = (preventBackClick = false) =>
  addModal({
    id: COMPONENT_ID,
    props: {},
    preventBackClick,
  })

export default {
  [COMPONENT_ID]: { Component: HonarioonPhoneMenu },
}
